/* eslint-disable no-undef */
/* eslint-disable babel/no-invalid-this */
/* eslint-disable babel/camelcase */
import $ from 'jquery';
import Cookies from 'js-cookie';

const COOKIE_NAME = "wishlistList";

const wishlistData = document.getElementById('wishlist-js');
const PRODUCT_WISHLIST_WISHLIST_EMPTY = wishlistData.getAttribute('data-products.wishlist.wishlist_empty');
const PRODUCT_WISHLIST_VIEW_PRODUCT = wishlistData.getAttribute('data-products.wishlist.view_product');
const OUT_OF_STOCK = wishlistData.getAttribute('data-oos');

try {
  if (Cookies.get(COOKIE_NAME) != null && Cookies.get(COOKIE_NAME) != '__' && Cookies.get(COOKIE_NAME) != '') {
    const str = String(Cookies.get(COOKIE_NAME)).split("__");
    for (let i = 0; i < str.length; i++) {
      if (str[i] != '') {
        Shopify.getProduct(str[i], (product) => {
          wishlist_product(product);
        });

      }
    }
  } else {
    emptyWishlist();
  }
  $('.currency .active').trigger('click');
} catch (err) {
     // ignore errors reading cookies
}

function emptyWishlist() {
  $(".wishlist_table").remove();
  $(".table-wrapper").append(`
    <div class='text-center alert alert-info empty-wishlist'>${PRODUCT_WISHLIST_WISHLIST_EMPTY}</div>
  `);
}

function wishlist_product(product) {
  const firstVariant = product.variants.find((variant) => variant.available === true);

  const price = firstVariant === undefined
    ? OUT_OF_STOCK
    : `<span class="money"> ${Shopify.formatMoney(firstVariant.price)} </span>`;

  $('.wishlist-box').append(`
      <tr class='${product.handle}'>
        <td class='product-remove'>
          <a href="#" class="remove remove_from_wishlist product-remove-js" title="Remove this product">
            ×
          </a>
        </td>
        <td class='product-thumbnail' style='width:100px;'>
          <a class="wishlist-item-link" href="${product.url}">
            <img loading="lazy" class="img-responsive" src="${product.featured_image}" alt="${product.title}">
          </a>
        </td>
        <td class='product-name'>
          <a class="wishlist-item-link" href="${product.url}">${product.title}</a>
        </td>
        <td class='wishlist-product-price product-price'>
          ${price}
        </td>
        <td class='product-add-to-cart'>
          <a class="button wishlist-item-link btn" href="${product.url}" rel="nofollow">${PRODUCT_WISHLIST_VIEW_PRODUCT}</a>
        </td>
      </tr>
    `);

  $('.wishlist-box').find(`.${product.handle}`).find('.product-remove-js')
    .click(function(event) {
      event.preventDefault();
      $(this).unbind();
      const item = $(this).parent().parent();
      let str = Cookies.get(COOKIE_NAME);
      str = str.replace(item.attr("class"), '');
      str = str.replace('____', '__');
      Cookies.set(COOKIE_NAME, str, {expires: 14, path: '/'});

      item.fadeOut(500);
      setTimeout(removeItem, 500, item);
    });
}
function removeItem(item) {
  item.remove();

  if (Cookies.get(COOKIE_NAME) == '__' || Cookies.get(COOKIE_NAME) == '') {
    emptyWishlist();
  }
}
